import React from "react"

const GetStarted = () => {
  return (
    <div className="getStarted">
      <h1>Get started in 5 minutes</h1>
      <h3>DigiWall supports multiple payment providers</h3>
      <div className="getStarted-process">
        <div className="getStarted-createAcc">
          <img
            className="getStarted-icon"
            src="/images/Homepage/create-an-account.svg"
            alt="Create an account"
          />
          <span>Create an account</span>
        </div>

        <div className="getStarted-line" />

        <div className="getStarted-linkPayments">
          <img
            className="getStarted-icon"
            src="/images/Homepage/link-to-payment-providers.svg"
            alt="Link to payment providers"
          />
          <span>Link to payment providers</span>
        </div>
      </div>
    </div>
  )
}

export default GetStarted
